import { render } from "./Login.vue?vue&type=template&id=20035664"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=20035664&lang=css"

import exportComponent from "C:\\Users\\Administrator.1LIZRQUYRIVXOVB\\github-classroom\\MUICCS\\cs340prj-Atiwat-R\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__